import { Col, Container, Row } from 'react-bootstrap';
import Parser from 'html-react-parser';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import Tabs from '../../Component/Tabs';
import { getSelectedLanguagePage } from '../../utils/helpers';
import classes from './TermsAndConditions.module.css';

const TermsAndConditions = () => {
  const { t } = useTranslation('webCommon');
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { cmsPages } = useSelector((state) => state.commonReducer);
  const pageData = getSelectedLanguagePage(selectedLanguage, cmsPages, 'termsAndConditions');
  const tabsOptions = [
    { id: 1, text: t('termsAndConditions.tab1'), value: 'user' },
    { id: 2, text: t('termsAndConditions.tab2'), value: 'company' }
  ];
  const [selectedTab, setSelectedTab] = useState(tabsOptions[0]);

  return (
    <div className={classes.page}>
      <Header containerClass="customContainer" />
      <div className={classes?.containerWrapper}>
        <Container className="customContainer py-4">
          <Row className={classes.row}>
            <Col md={12}>
              <h4>{t('termsAndConditions.title')}</h4>
            </Col>
            <Col md={12}>
              <Tabs
                tabsData={tabsOptions}
                value={selectedTab}
                setValue={setSelectedTab}
                className={classes.tab}
                tabClass={classes.tabLi}
              />
            </Col>
            <Col md={12}>
              <div className={classes.decriptionBox}>
                {selectedTab?.value === 'user'
                  ? Parser(pageData?.forUsers?.htmlDescription)
                  : Parser(pageData?.forCompaniesAndAdvertisers?.htmlDescription)}
              </div>
            </Col>
          </Row>

          <div className={classes?.buttonContainer}></div>
        </Container>
      </div>
      <Footer showDownload={false} />
    </div>
  );
};

export default TermsAndConditions;
